// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZHveE","delete":"styles_delete__2S3hl","update":"styles_update__2ptw4","add":"styles_add__2klOK"};